module.exports = __webpack_public_path__ + "img/world.932c6dfc.svg";